var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2837 8.47754L11.9952 15.9775M8.00481 15.9775L7.71635 8.47754M16.023 5.80301C16.308 5.84605 16.592 5.8921 16.875 5.94111M16.023 5.80301L15.1332 17.3713C15.058 18.3482 14.2434 19.1025 13.2637 19.1025H6.73631C5.75655 19.1025 4.94198 18.3482 4.86683 17.3713L3.97696 5.80301M16.023 5.80301C15.0677 5.65874 14.1013 5.54825 13.125 5.47281M3.125 5.94111C3.40798 5.8921 3.69198 5.84605 3.97696 5.80301M3.97696 5.80301C4.93231 5.65874 5.89874 5.54825 6.875 5.47281M13.125 5.47281V4.70936C13.125 3.72656 12.3661 2.90607 11.3838 2.87464C10.9244 2.85994 10.463 2.85254 10 2.85254C9.53696 2.85254 9.07565 2.85994 8.61618 2.87464C7.63388 2.90606 6.875 3.72656 6.875 4.70936V5.47281M13.125 5.47281C12.0938 5.39312 11.0516 5.35254 10 5.35254C8.94836 5.35254 7.9062 5.39312 6.875 5.47281",
    stroke: "#5E5E5E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.57a8e689f1045810f04d7ab577240eb1.svg";
export { ForwardRef as ReactComponent };